// extracted by mini-css-extract-plugin
export default {"textarea":"textarea_textarea__Xgv+0","fullWidth":"textarea_fullWidth__hUjAl","error":"textarea_error__iBwA6"};